
// 插件路由
const bill = () => import(/* webpackChunkName: "bill" */ '~/addon/bill/pages/bill.vue')

const routes = [
	{
        path: '/bill',
        component: bill
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/bill/router/index.js